export enum UploadCandidateStatuses {
  Uploading = 'UPLOADING',
  Parsing = 'PARSING',
  Analyzing = 'ANALYZING',
  MatchingFinished = 'MATCHING_FINISHED',
  Searching = 'SEARCHING',
  Error = 'ERROR',
}
